import {
  OrchestratorCheckoutEnrollRequest,
  OrchestratorCheckoutEnrollResponse
} from 'types/api/checkout';
import { OrchestratorErrorResponse } from 'types/api/orchestrator';
import { FetchResponse } from 'types/fetch';
import endpoints from '../endpoints';
import fetchReq from '../fetch';

//START GENAI@GHCOPILOT
type CheckoutEnrollOptions = {
  accessToken?: string;
  payload: OrchestratorCheckoutEnrollRequest;
  sessionId: string;
  /* START GENAI@GHCOPILOT */
  uctpAddCard: boolean;
  /* END GENAI@GHCOPILOT */
  vsbFlow?: boolean;
};

export function fetchCheckoutEnroll({
  accessToken,
  payload,
  sessionId,
  uctpAddCard,
  vsbFlow
}: CheckoutEnrollOptions): FetchResponse<
  OrchestratorCheckoutEnrollResponse,
  OrchestratorErrorResponse
> {
  const headers: Record<string, string> = {
    dfpSessionId: sessionId
  };

  if (accessToken) {
    headers.access_token = accessToken;
  }

  let url = `${endpoints.orchestrator.checkoutEnroll}`;

  //if add card don't pass vsbFlow
  if (vsbFlow) {
    url += '?vsbFlow=true';
  }

  /* START GENAI@GHCOPILOT */
  if (vsbFlow && uctpAddCard) {
    url = `${endpoints.orchestrator.checkoutPrepare}`;
  }
  /* END GENAI@GHCOPILOT */

  return fetchReq({
    body: payload,
    headers,
    mark: 'checkout_integrated_fetch_enroll',
    method: 'POST',
    url
  });
  //END GENAI@GHCOPILOT
}
